<!-- 库存周转分析 -->
<template>
  <div class='page_content'>
    <div class="page_content_top">
      <div class="page_content_top_line">
        <el-form label-width="100px" :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini">
            <el-form-item label="开始日期">
              <label slot="label" :style="$common.labelStyle('开始日期')"
                            v-html="'开始日期'"></label>
            <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
              type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <label slot="label" :style="$common.labelStyle('结束日期')"
                            v-html="'结束日期'"></label>
            <el-date-picker class="form_codition" size="mini" v-model="getRequestData.end" @change="changeTime" format="yyyy 年 MM 月 dd 日"
              value-format="timestamp" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="通用名称">
            <label slot="label" :style="$common.labelStyle('通用名称')"
                            v-html="'通用名称'"></label>
            <el-input class="form_codition" v-model.trim="getRequestData.bgmName" clearable></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="searchData">查询</el-button>
            <el-button type="primary" size="mini" icon="el-icon-share" @click="export2Excel">导出</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-tabs>
      <el-tab-pane label="流水信息">
        <div class="page_content_center">
          <u-table size="mini" id="tableData" :data="dataShow" :height="tableHeight" :key="$store.state.tableNum" border :row-style="rowStyle"
            style="width: 100%" show-summary :summary-method="getSummaries" stripe ref="stockTable"
            :header-cell-style="{ background: '#fff' }"  :row-height="35"  row-key="index" use-virtual>
            <u-table-column align="center" show-overflow-tooltip prop="bgmCode" label="商品编码" width="150px"
              :sortable="true"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="bgmName" label="通用名称" width="200px">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="spec" label="规格" width="200px"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="manufacturer" label="生产商" width="200px">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="placeorigin" label="产地" min-width="100px">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="batchno" label="批号" min-width="100px">
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="prodate" label="生产日期" min-width="110px">
              <template slot-scope="scope">
                <span v-if="scope.row.prodate">
                  {{ $common.getLocalTime(scope.row.prodate) }}
                </span>
              </template>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="expidate" label="失效日期" min-width="110px">
              <template slot-scope="scope">
                <span v-if="scope.row.expidate">
                  {{ $common.getLocalTime(scope.row.expidate)}}
                </span>
              </template>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="coName" label="货主名称"></u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="inItCount" label="期初" >
              <u-table-column align="center" show-overflow-tooltip prop="inItCount" label="数量" width="120px"
                :sortable="true"></u-table-column>
              <u-table-column align="center" show-overflow-tooltip prop="inItMoney" label="金额" width="120px"
                :sortable="true"></u-table-column>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="inCount" label="入库" >
              <u-table-column align="center" show-overflow-tooltip prop="inCount" label="数量" width="120px"
                :sortable="true"></u-table-column>
              <u-table-column align="center" show-overflow-tooltip prop="inMoney" label="金额" width="120px"
                :sortable="true"></u-table-column>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="outCount" label="出库" >
              <u-table-column align="center" show-overflow-tooltip prop="outCount" label="数量" width="120px"
                :sortable="true"></u-table-column>
              <u-table-column align="center" show-overflow-tooltip prop="outMoney" label="金额" width="120px"
                :sortable="true"></u-table-column>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip label="期末" >
              <u-table-column align="center" show-overflow-tooltip prop="endCount" label="数量" width="120px"
                :sortable="true"></u-table-column>
              <u-table-column align="center" show-overflow-tooltip prop="endMoney" label="金额" width="120px"
                :sortable="true"></u-table-column>
            </u-table-column>
            <u-table-column align="center" show-overflow-tooltip prop="zzl" label="周转率(%)"></u-table-column>
          </u-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div class="page_content_bottom">
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                :current-page.sync="currentPage" :page-size.sync="pageSize" :page-sizes="[10,30,100,200,300]"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "dataQueryTemplate",
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        bgmName: '', //	通用名称
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
      },
      activeName: "0",
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      selectedDataIndex: 0,
      reportConditionVos: [],
      reportModuleVos: [],
      tabIndex: 0,
      totalPageData: [],
      dataShow:[],
      // 共几页
      pageNum: 1,
      // 每页显示数量
      pageSize: 10,
      // 当前显示页码
      currentPage: 1,
      // 总共多少条数据
      total: 1,
      // 当前要显示的数据
      pageSizes: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //方法集合
  methods: {
    // 选中行底色逻辑
    rowStyle({
      row,
      rowIndex
    }) {
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },
    //获取当天最后时间戳
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1
        this.getRequestData.end = time
      }
    },
    toDetail(orderId) {
      console.log(orderId);
      this.$parent.toDetail(orderId);
      //    this.$parent.$parent.$parent.toDetail(orderId)
    },
    //   查询
    searchData() {
        this.tableHeight = this.$common.getTableHeight()
      this.getRequestData.page = 1;
      this.currentPage = 1
      this.getDataList()
    },
    //表格数据写入excel
    export2Excel() {
      this.rpmName = '库存周转分析'; //获取当前导出表格标题
      var nameList = ['商品编码', '通用名称', '商品名称', '货主名称', '生产商', '产地', '规格', '期初数量', '期初金额','入库数量','入库金额', '出库数量','出库金额', '期末数量', '期末金额', '周转率(%)']; //表格头 显示的所有字段
      var fieldList = ['bgmCode', 'bgmName', 'bgiGename', 'coName', 'manufacturer', 'placeorigin', 'spec', 'inItCount', 'inItMoney','inCount', 'inMoney','outCount', 'outMoney','endCount', 'endMoney', 'zzl']; //所有字段 显示的所有字段
      var timeList = []; //date类型的字段 导出之前进行格式转换
      // 导出业务逻辑 引用封装好的js方法
      require.ensure([], () => {
        const {
          export_json_to_excel
        } = require("@/assets/excel/Export2Excel");
        //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
        const tHeader = nameList; // 导出的excel表头名信息
        const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
        const list = this.returnData.list; // 查询的数据list
        // 进行数据json map 格式转换
        const data = this.formatJson(filterVal, list);
        // 调用方法传参      表头名信息 数据  导出的表格名称
        export_json_to_excel(tHeader, data, this.rpmName);
      });
      // 导出次数接口
      var token = sessionStorage.getItem("token");
      let params = {
        exportCount: this.list.length,
        featuresName: this.rpmName
      }
      exportRecordAdd(params, token).then((res) => {
        if (res.status === 200) { }
      });
    },
    //格式转换方法
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //表格求和
    getSummaries(param) {
      const {
        columns,
        data
      } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else if (index >= 9) {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return this.toDecimal(prev + curr);
              } else {
                return this.toDecimal(prev)
              }
            }, 0);
            sums[index] =  this.$common.getDecimalInfo(3,sums[index])
            // sums[index] = sums[index].toFixed(2)
            // sums[index] += ' 元';
          } else {
            sums[index] = 'N/A';
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.stockTable.doLayout()
      })
      return [sums];
    },
    toDecimal(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return;
      }
      f = Math.round(x * 100) / 100;
      return f;
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.statisticsQueryStockTurnRate(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result
        this.total = this.returnData.list.length
        this.$store.state.tableNum=this.$store.state.tableNum?false:true
        this.calcPageData()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 数据翻页
    setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },
        // 前端分页逻辑
        calcPageData() {
            console.log(this.currentPage);
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.returnData.list.length > 1) {
                this.pageNum = Math.ceil(this.returnData.list.length / this.pageSize) || 1;
            }
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.returnData.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
            // this.fullscreenLoading = false
        },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    var objs=this.$common.getSearch(this.getRequestData,'start','end','page','rows',30)
            for (const key in objs) {
                this.$set(this.getRequestData,key,objs[key])
            }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$common.getTableHeight()
    })
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight(); }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
  overflow-y: auto;
}

.dis {
  display: flex;
  flex-wrap: wrap !important;
}
</style>
